import { Scene } from "phaser";

import { GButton } from "../gameobjects/GButton";
//import NinePatch from "phaser3-rex-plugins/plugins/ninepatch";

// The HUD scene is the scene that shows the points and the remaining time.
export class BalanceAlertScene extends Scene {
    
    constructor() {
        super("BalanceAlertScene");

    }

    init(data) {

    }

    create() {
        //this.userNameText = this.add.text(this.scale.width/2, this.scale.width/2, `QuickPickScene`).setOrigin(0.5);
        this.cameras.main.setBackgroundColor('rgba(21, 21, 21, 0.85)');

        this.graphics = this.add.graphics();

        this.graphics.fillStyle(0x212121, 1);

        this.graphics.fillRoundedRect(32,this.scale.height/2 - 343, 343*2 , 246 *2, 32);


        this.title = this.add.text(this.scale.width/2,this.scale.height/2 - 343 + 64, `INSUFFICIENT FUNDS`,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')



        this.title = this.add.text(this.scale.width/2, this.scale.height/2 -64,"You are lacking funds to purchase the tickets. Top up your wallet or remove some tickets and try again.",  
            { fontFamily: 'Oswald', fontSize: 32, 
                color: '#ffffff',
                align: 'center',
                wordWrap: { width:  343*2 - 128, useAdvancedWrap: true }
            }).setOrigin(0.5,1);

        const ButtonCancel = new GButton( this, this.scale.width/2, this.scale.height/2+ 52, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            nineslice: {},
            text: {
                value:'BACK TO TICKETS',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                //console.log('Button ButtonQuickPick!');
                this.scene.stop()
                this.scene.start("BuyTicketScene" , {})
                
                //this.scene.launch("QuickPickScene")
             }
        });

        ButtonCancel.setScale(0.75);

    }

    
}